



















































































































































































































































































import Vue, { PropType } from 'vue';
import { applicationRepository, documentRepository } from '@/api';
import router from '@/router';
import AppAlerts from '@/components/molecules/appAlerts/AppAlerts.vue';
import Icon from '@/components/atoms/icon/Icon.vue';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import ButtonSpacer from '@/components/molecules/buttonSpacer/ButtonSpacer.vue';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import AppContent from '@/components/atoms/appContent/AppContent.vue';
import AppLayer from '@/components/molecules/appLayer/AppLayer.vue';
import AppScrollbar from '@/components/atoms/appScrollbar/AppScrollbar.vue';
import TechnologyIcon from '@/components/atoms/technologyIcon/TechnologyIcon.vue';
import StatusInfoAccordion from '@/components/molecules/statusInfoAccordion/StatusInfoAccordion.vue';
import { ApplicationStatus } from '@/enums/applicationStatus';
import { MessageType } from '@/enums/messageType';
import { alertService } from '@/services/alertService';
import type { Application } from '@/api/interfaces/application/application';
import { SpinnerState } from '@/enums/spinnerState';
import { Address } from '@/api/interfaces/application/address';
import { camelCase, debounce as _debounce, DebouncedFunc } from 'lodash';
import { ApplicationOverviewGridContent } from '@/api/interfaces/content/app/applicationOverviewGridContent';
import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';
import { ConfirmationLayerContent } from '@/api/interfaces/content/common/confirmationLayerContent';
import { ServiceError } from '@/api/interfaces/serviceError';
import { downloadFile } from '@/services/fileDownloadService';
import { isServiceError } from '@/api/interfaces/typeGuards';
import { EnergyTypeFieldType } from '@/types/forms/shared/energyTypeFieldType';
import { PlantTypeFieldTypeForGenerationTypeFormStep } from '@/types/forms/shared/plantTypeFieldType';
import { sanitizeTextInputValue } from '@/utilities/stringParsingUtils';
import { Pagination } from '@/api/interfaces/common/pagination';
import { ApplicationUpdateDataModel } from '@/types/app/application/applicationUpdateDataModel';
import ApplicationPagination from '@/components/organisms/applicationPagination/ApplicationPagination.vue';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';
import { DateRange } from '@/types/forms/shared/dateRange';

interface GridColumn {
    key: string;
    defaultSortDirection: 'asc' | 'desc';
}

const gridColumns: GridColumn[] = [
    { key: 'technology', defaultSortDirection: 'asc' },
    { key: 'applicationId', defaultSortDirection: 'asc' },
    { key: 'applicationNumber', defaultSortDirection: 'asc' },
    { key: 'created', defaultSortDirection: 'desc' },
    { key: 'submitted', defaultSortDirection: 'desc' },
    { key: 'completed', defaultSortDirection: 'desc' },
    { key: 'name', defaultSortDirection: 'asc' },
    { key: 'address', defaultSortDirection: 'asc' },
    { key: 'status', defaultSortDirection: 'asc' },
];

export default Vue.extend({
    name: 'ApplicationOverviewGrid',
    components: {
        AppAlerts,
        AppButton,
        AppContent,
        AppLayer,
        AppScrollbar,
        ButtonSpacer,
        Icon,
        SpinnerArea,
        ApplicationPagination,
        TechnologyIcon,
        StatusInfoAccordion,
    },
    props: {
        entries: {
            type: Array as PropType<Application[]>,
            default: () => [],
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        content: {
            type: Object as PropType<ApplicationOverviewGridContent>,
            required: true,
        },
        copyApplicationConfirmationLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        deleteApplicationConfirmationLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        deleteApplicationCommitmentConfirmationLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        enumsContent: {
            type: Object as PropType<EntryListContent>,
            required: true,
        },
        gridSpinner: {
            type: String as PropType<SpinnerState>,
            required: true,
        },
        applicationUpdateData: {
            type: Object as PropType<ApplicationUpdateDataModel>,
            default: () => new ApplicationUpdateDataModel(),
        },
        applicationStatusItems: {
            type: Object as PropType<Record<
                string,
                ApplicationStatusDetail
            > | null>,
            default: null,
        },
    },
    data() {
        return {
            spinner: SpinnerState.off,
            alertService,
            alert: '',
            type: '',
            gridColumns: gridColumns,
            applicationIdToDelete: null as string | null,
            applicationStatusToDelete: null as ApplicationStatus | null,
            applicationIdToCopy: null as string | null,
            internalApplicationUpdateData: this.applicationUpdateData,
            updateDataDebounce: null as null | DebouncedFunc<() => void>,
        };
    },
    computed: {
        spinnerState(): SpinnerState {
            return this.gridSpinner == SpinnerState.off
                ? this.spinner
                : this.gridSpinner;
        },
        hasApplications(): boolean {
            return this.entries.length > 0;
        },
        activeDeleteConfirmationContent(): ConfirmationLayerContent {
            return this.applicationStatusToDelete ===
                ApplicationStatus.proposalSent ||
                this.applicationStatusToDelete ===
                    ApplicationStatus.operatorDeclarationReceived
                ? this.deleteApplicationCommitmentConfirmationLayerContent
                : this.deleteApplicationConfirmationLayerContent;
        },
    },
    methods: {
        sanitizeTextInputValue,
        camelCase,
        renderApplicationAddress(address: Address): string {
            const postCodeAndCity = `${address.postCode ?? ''} ${
                address.city ?? ''
            }`.trim();
            const streetAndHousenumber = `${address.street ?? ''} ${
                address.houseNumber ?? ''
            }`.trim();
            const meadowAndLot = `${address.meadow ?? ''} ${
                address.lot ?? ''
            }`.trim();
            const subdistrictAndMeadowAndLot = `${
                address.subdistrict ?? ''
            } ${meadowAndLot}`.trim();
            return `${
                postCodeAndCity ? `${postCodeAndCity}<br />` : ''
            }${streetAndHousenumber} ${subdistrictAndMeadowAndLot}`.trim();
        },
        orderColumnBy(
            columnKey: string,
            defaultSortDirection: 'asc' | 'desc',
        ): void {
            if (this.internalApplicationUpdateData.sortByColumn === columnKey) {
                this.internalApplicationUpdateData.sortDirection =
                    this.internalApplicationUpdateData.sortDirection === 'asc'
                        ? 'desc'
                        : 'asc';
            } else {
                this.internalApplicationUpdateData.sortByColumn = columnKey;
                this.internalApplicationUpdateData.sortDirection = defaultSortDirection;
            }

            this.updateData();
        },
        getTechnology(
            energyType: EnergyTypeFieldType,
            plantType: PlantTypeFieldTypeForGenerationTypeFormStep,
        ): string {
            switch (energyType) {
                case 'biogas':
                case 'biowaste':
                    return 'bio';
                default:
                    return plantType || '';
            }
        },
        startApplication(): void {
            router.push('/antrag');
        },
        canContinue(status: ApplicationStatus) {
            return status === ApplicationStatus.draft;
        },
        canDownload(status: ApplicationStatus) {
            return (
                status !== ApplicationStatus.draft &&
                status !== ApplicationStatus.deleted
            );
        },
        canDelete(status: ApplicationStatus) {
            return (
                status !== ApplicationStatus.finishNotificationReceived &&
                status !== ApplicationStatus.operational &&
                status !== ApplicationStatus.deleted
            );
        },
        canCopy(status: ApplicationStatus) {
            return (
                status !== ApplicationStatus.draft &&
                status !== ApplicationStatus.deleted &&
                status !== ApplicationStatus.rejected
            );
        },
        prepareCopyingApplication(applicationId: string) {
            this.applicationIdToCopy = applicationId;
        },
        cancelCopyingApplication() {
            this.applicationIdToCopy = null;
        },
        copyApplication() {
            if (!this.applicationIdToCopy) {
                return;
            }

            const applicationId = this.applicationIdToCopy;
            this.applicationIdToCopy = null;
            this.spinner = SpinnerState.transparent;

            applicationRepository
                .copyApplication(applicationId)
                .then((response) => {
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.info,
                            identifier: 'applications.copied',
                        },
                    });

                    this.$emit('copy-application', response);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        prepareDeletingApplication(
            applicationId: string,
            status: ApplicationStatus,
        ) {
            this.applicationIdToDelete = applicationId;
            this.applicationStatusToDelete = status;
        },
        cancelDeletingApplication() {
            this.applicationIdToDelete = null;
            this.applicationStatusToDelete = null;
        },
        deleteApplication() {
            if (!this.applicationIdToDelete) {
                return;
            }

            const applicationId = this.applicationIdToDelete;
            this.applicationIdToDelete = null;
            this.applicationStatusToDelete = null;
            this.spinner = SpinnerState.transparent;

            applicationRepository
                .deleteApplication(applicationId)
                .then(() => {
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.info,
                            identifier: 'applications.deleted',
                        },
                    });

                    this.$emit('delete-application', applicationId);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        async downloadDocumentsZip(applicationId: string) {
            this.spinner = SpinnerState.transparent;

            documentRepository
                .downloadDocument('applicationDocumentsZip', applicationId)
                .then((response) => {
                    downloadFile(response.bytes, response.fileName);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        handlePageChanged(page: number): void {
            this.internalApplicationUpdateData.offset =
                (page - 1) * this.internalApplicationUpdateData.limit;
            this.updateData();
        },
        handleQueryChanged(query: string, updateData = true): void {
            this.internalApplicationUpdateData.offset = 0;
            this.internalApplicationUpdateData.query = query;
            if (updateData) {
                this.updateData();
            }
        },
        handleDateSentAtChanged(
            dateSentAt: DateRange,
            updateData = true,
        ): void {
            this.internalApplicationUpdateData.dateSentAtStart =
                dateSentAt?.start;
            this.internalApplicationUpdateData.dateSentAtEnd = dateSentAt?.end;
            if (updateData) {
                this.updateData();
            }
        },
        handleStatusesChanged(statuses: string[], updateData = true): void {
            this.internalApplicationUpdateData.statuses = statuses;
            if (updateData) {
                this.updateData();
            }
        },
        handleFilterReset(): void {
            this.handleQueryChanged('', false);
            this.handleDateSentAtChanged({ start: '', end: '' }, false);
            this.handleStatusesChanged([], false);
            this.updateData();
        },
        updateData(): void {
            this.spinner = SpinnerState.transparent;

            if (this.updateDataDebounce) {
                this.updateDataDebounce.cancel();
            }

            this.updateDataDebounce = _debounce(() => {
                this.$emit(
                    'update-applications',
                    this.internalApplicationUpdateData,
                );
                this.spinner = SpinnerState.off;
            }, 500);

            this.updateDataDebounce();
        },
    },
});
